import * as React from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Flame, TrendingUp, Star } from "lucide-react";

const SPECIAL_TABS = [
  { id: "__popular", title: "Populer", icon: Flame },
  { id: "__top_rated", title: "En Begenilen", icon: Star },
];

export const CategoryTabs = ({ categories, value, onChange }) => {
  return (
    <Tabs value={value} onValueChange={onChange}>
      <TabsList className="h-auto flex flex-wrap gap-1.5 bg-transparent p-0">
        {/* All games */}
        <TabsTrigger
          value={categories?.[0]?.id ?? "new"}
          className="rounded-full px-4 py-1.5 text-xs sm:text-sm data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
        >
          Tum Oyunlar
        </TabsTrigger>

        {/* Special tabs */}
        {SPECIAL_TABS.map((st) => (
          <TabsTrigger
            key={st.id}
            value={st.id}
            className="rounded-full px-4 py-1.5 text-xs sm:text-sm gap-1.5 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <st.icon className="size-3.5" />
            {st.title}
          </TabsTrigger>
        ))}

        {/* Category tabs */}
        {categories?.slice(1).map((cat) => (
          <TabsTrigger
            key={cat.id}
            value={cat.id}
            className="rounded-full px-4 py-1.5 text-xs sm:text-sm data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            {cat.title}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
